// 网鱼 优惠券
import React from 'react';

import { SourceChannelType } from '@/config/constant';
import { Icoupon } from '@/redux/reducers/guest';
import noCouponUrl from '@/components/SelectDiscountCoupon/component/img/no_coupon.png';
import styles from '@/components/SelectDiscountCoupon/index.module.scss';
import { renderIntlLabel } from '@/utils';
import CouponItem from './CouponItem';

export interface ICouponItem extends Icoupon {
  isChecked: boolean;
  isDisabled: boolean;
}

interface IProps {
  channelType?: SourceChannelType;
  couponList: ICouponItem[];
  handleSelect: (couponNo: string) => void;
}

const Index: React.FC<IProps> = (props) => {
  const { couponList, channelType, handleSelect } = props;
  const couponSelectAble = channelType === SourceChannelType.WALK_IN; // 网鱼券是否可用

  const renderTipContent = () => {
    return (
      <div style={{ marginBottom: '16px' }}>
        {renderIntlLabel('guest_coupon_label_current_avalible')}
        <span className={styles.number}>{couponList.length}</span>
        {renderIntlLabel('guest_coupon_label_sheet')}，
        {renderIntlLabel('guest_coupon_label_has_selected')}
        <span className={styles.number}>{couponList.filter((item) => item.isChecked).length}</span>
        {renderIntlLabel('guest_coupon_label_sheet')}
      </div>
    );
  };

  return (
    <div>
      {renderTipContent()}
      {couponList.length ? (
        <div className={styles.couponList}>
          {couponList.map((item) => (
            <CouponItem
              key={item.couponNo}
              isCanSelect={couponSelectAble}
              coupon={item}
              checked={item.isChecked}
              disabled={item.isDisabled}
              onClick={handleSelect}
            />
          ))}
        </div>
      ) : (
        <div className={styles.noData}>
          <img src={noCouponUrl} alt={renderIntlLabel('guest_msg_no_coupon')} />
          <div>{renderIntlLabel('guest_msg_no_coupon')}</div>
        </div>
      )}
    </div>
  );
};

export default Index;
